// extracted by mini-css-extract-plugin
export default {"loaderWrap":"loaders_loaderWrap__iYRAk","loader":"loaders_loader__KrFna","rotate":"loaders_rotate__gCi7n","ball1":"loaders_ball1__a70-D","ball2":"loaders_ball2__ANPct"};